import { useId } from 'react'
import useResponsiveDesign from 'hooks/useResponsiveDesign'

export function V4LoaderArrow() {
  const { isMobile } = useResponsiveDesign()
  const gradientId = useId()

  if (isMobile) {
    return (
      <svg width="25" height="18" viewBox="0 0 27.4 20" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M1 10.049L26 10.049M17.5433 19L26 10.049L17.4508 1"
          stroke={`url(#${gradientId})`}
          strokeOpacity="0.8"
          strokeWidth="2"
          strokeLinecap="round"
        />
        <defs>
          <linearGradient id={gradientId} x1="0.678" y1="10" x2="23.272" y2="10" gradientUnits="userSpaceOnUse">
            <stop stopColor="#E5E5E5" />
            <stop offset="1" />
          </linearGradient>
        </defs>
      </svg>
    )
  }

  return (
    <svg width="58" height="23" viewBox="0 0 58 23" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M0.75 11.4095H56.5188M56.5188 11.4095L45.8593 0.75M56.5188 11.4095L45.9747 21.9536"
        stroke={`url(#${gradientId})`}
        strokeWidth="1.5"
        strokeLinecap="round"
      />
      <defs>
        <linearGradient id={gradientId} x1="44.5188" y1="11.3518" x2="0.75" y2="11.3518" gradientUnits="userSpaceOnUse">
          <stop />
          <stop offset="1" stopColor="#EBEBEB" />
        </linearGradient>
      </defs>
    </svg>
  )
}
